import { gql } from '@apollo/client';

export const MARK_MESSAGE_THREAD_READ = gql`
  mutation MarkMessageThreadRead($messageThreadId: ID!) {
    markMessageThreadRead(input: { messageThreadId: $messageThreadId }) {
      messageThread {
        id
        unreadMessageCount
      }
      errors
    }
  }
`;
